import { moduleFactory } from "@/factories/module";
import { getBackendAssetProxyUrl } from "@/managers/backend-api-client/initializeBackendApiManager";

/**
 * Asset proxy configuration for the common editor.
 * This type matches MemCommonEditorAssetProxyConfig from @mem-labs/common-editor.
 */
export type AssetProxyConfig = {
  /** Base URL of the proxy endpoint (e.g. https://www.mem.storage/proxy). */
  baseUrl: string;
  auth: {
    assetAccessToken: string;
    /** ISO-8601 timestamp string for when the token expires. Null when there is no expiration. */
    expiresAt: string | null;
  } | null;
};

export { getBackendAssetProxyUrl };

export const buildProxiedAssetUrl = ({
  originalUrl,
  token,
}: {
  originalUrl: string;
  token: string;
}): string => {
  const baseUrl = getBackendAssetProxyUrl();
  const params = new URLSearchParams({
    url: originalUrl,
    token,
  });
  return `${baseUrl}?${params.toString()}`;
};

export const buildAssetProxyConfig = ({
  token,
  expiresAt,
}: {
  token: string;
  expiresAt: string | null;
}): AssetProxyConfig => {
  return {
    baseUrl: getBackendAssetProxyUrl(),
    auth: {
      assetAccessToken: token,
      expiresAt,
    },
  };
};

export const assetProxyModule = moduleFactory.create({
  getBackendAssetProxyUrl,
  buildProxiedAssetUrl,
  buildAssetProxyConfig,
});
